// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"280a7325","551":"bc71bbd4","828":"3b77406e","849":"4e8ae492"}[chunkId] + ".chunk.js";
};